import { PolicyInfoResponse } from 'all-in-one-shared-api/dist/apis/policy/PolicyInfoResponse';

export const getLatestRenewalNumbers = (
  policyInfo: PolicyInfoResponse[],
  memberType: string,
  amountOfNumber = 2,
): number[] => {
  if (!policyInfo || policyInfo.length === 0) return [];

  return policyInfo
    .filter((info) => info.memberType === memberType)
    .map((i) => i.renewalNumber ?? -999)
    .filter((number) => number !== undefined && number !== null && number !== -999)
    .sort((a, b) => b - a)
    .slice(0, amountOfNumber);
};
